/**
 * 五日分时成交量state
 */
import TrendFiveFootDectorator from '../dectorator/trendfivefootdectorator';
import TrendTurnoverState from '../trendturnover';
import {mergeModelData} from '../../util';
const model = {
  fiveAmount: {
    Type: Number
  }
};
class TrendFiveTurnoverState extends TrendFiveFootDectorator(TrendTurnoverState) {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
}
export default TrendFiveTurnoverState;